import Fixtures from "./Fixtures";
export default Fixtures;
